import { mapObject } from '@client/toolkit';
import { Route, Routes } from 'react-router-dom';
import { ProfileLayout } from './profile.layout';
import { ProfileCompany } from './routes';
import { ProfileInvoices } from './routes/profile.invoices';
import { ProfileUsers } from './routes/profile.users';
import { ProfileContactPersons } from './routes/profile.contact-persons';
import { PermissionProtectedRoute } from '../../components/permission-protected-route';
import { PermissionKeys } from '@client/api';

export const ProfilePaths = {
  Profile: '/profile',
  Company: '/profile/company',
  Users: '/profile/users',
  ContactPersons: '/profile/contact-persons',
  Invoices: '/profile/invoices',
};

const RouterPaths = mapObject(ProfilePaths, (val: string) => val.replace(ProfilePaths.Profile, ''));

export const ProfileRouter = () => (
  <Routes>
    <Route element={<ProfileLayout />}>
      <Route index element={<ProfileCompany />} />
      <Route path={RouterPaths.Company} element={<ProfileCompany />} />
      <Route
        path={RouterPaths.Users}
        element={
          <PermissionProtectedRoute requiredPermission={[PermissionKeys.Tenant.UsersList]}>
            <ProfileUsers />
          </PermissionProtectedRoute>
        }
      />
      <Route path={RouterPaths.ContactPersons} element={<ProfileContactPersons />} />
      <Route path={RouterPaths.Invoices} element={<ProfileInvoices />} />
    </Route>
  </Routes>
);
